import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.p3z_1 = sink;
        this.q3z_1 = false;
        this.r3z_1 = new (Buffer())();
      }
      g3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.r3z_1.g3v(source, byteCount);
        this.s3z();
        return Unit_instance;
      }
      w3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.r3z_1.w3y(byteString);
        return this.s3z();
      }
      y3y(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.r3z_1.y3y(string);
        return this.s3z();
      }
      z3y(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.r3z_1.z3y(string, beginIndex, endIndex);
        return this.s3z();
      }
      a3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.r3z_1.a3z(b);
        return this.s3z();
      }
      s3z() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.r3z_1.h3y();
        if (byteCount > 0n) {
          this.p3z_1.g3v(this.r3z_1, byteCount);
        }
        return this;
      }
      qc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.q3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.r3z_1.i3v_1 > 0n) {
          this.p3z_1.g3v(this.r3z_1, this.r3z_1.i3v_1);
        }
        this.p3z_1.qc();
        return Unit_instance;
      }
      q6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.q3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.r3z_1.i3v_1 > 0n) {
              this.p3z_1.g3v(this.r3z_1, this.r3z_1.i3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.p3z_1.q6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.q3z_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.p3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
